<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'TransferTypeList' }" class="nav-link">Typy przelewów</router-link>/Nowy typ przelewu</h2></page-title>

    <div class="col page-element">
      <alert-loading v-if="loading"></alert-loading>
      <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

      <TransferTypeForm v-if="!loading" :handle-submit="create" :values="item" :errors="violations"></TransferTypeForm>
    </div>
  </b-container>
</template>

<script>
  import TransferTypeForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('transfertype/create');

  export default {
    components: {
      TransferTypeForm
    },
    data: function() {
      return {
        item: {}
      }
    },
    created(){
      this.$store.dispatch('transfertype/create/reset');
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
        this.$store.dispatch('transfertype/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'TransferTypeUpdate', params: { id: created['id']} });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?776446c6